<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="entity.id"
               :value="entity.id"
               @click.stop
               @change="onChange"
               :checked="isChecked"
        />
        <label
            :for="entity.id"
            @click.stop
            v-translate>Vybrat
        </label>
      </td>
        <td :data-th="'MAC adresa' | translate" class="first_data"><strong>{{ entity.mac_address }}</strong></td>
        <td :data-th="'Datum vytvoření' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
      <td></td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "RegisteredMacAddressRow",
    mixins: [rowActions],
		data() {
			return {
				moduleName: 'RegisteredMacAddressRow',
			}
		},
		props: {
			entity: Object,
		},
		methods: {
			goToDetail(e, id) {
				this.$router.push({name: 'registeredMacAddressBatchDetail', params: {id: this.entity.id_batch_operation}})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/RegisteredMacAddressRow.vue